import React, { useContext, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { axiosUrl } from "../../api/axios";
// import axios from "../../api/axios";
import { UserContext } from "../../App";

const LoginComp = () => {
  const { setUserData } = useContext(UserContext);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const [errMsg, setErrMsg] = useState("");
  const errRef = useRef();

  const loginUser = async (e) => {
    e.preventDefault();

    try {
      const User = {
        email: email,
        password: password,
      };
      const loginResponse = await axiosUrl.post("/users/login", User);

      setUserData({
        token: loginResponse.data.token,
        user: loginResponse.data.user,
      });
      localStorage.setItem("auth-token", loginResponse.data.token);

      window.location.href = "/dashboard";

      return false;
    } catch (err) {
      err.response.data.msg === "user doesn't exist" ||
      err.response.data.msg === "Wrong Password"
        ? setErrMsg("Incorrect Email or Password")
        : setErrMsg("Oops No Server Response.. Pls try again later...");

      // console.log(err);

      // err.response.data.msg === "Wrong Password"
      //   ? setErrMsg("Incorrect Password")
      //   : setErrMsg("Oops No Server Response.. Pls try again later...");
    }
  };

  return (
    <form onSubmit={loginUser}>
      {/* {userData.user.email} */}
      <div className="inner">
        <p
          ref={errRef}
          className={errMsg ? "d-block" : "d-none"}
          style={{ color: "red", marginBottom: "1rem" }}
        >
          <i className="fas fa-info-circle mx-2"></i>
          {errMsg}
        </p>

        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            placeholder="Enter your Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="form-group password">
          <div className="password-label">
            <label htmlFor="password">Password</label>
            <Link to="/login">
              <label className="forgot-password">Forgot Password?</label>
            </Link>
          </div>
          <input
            type={showPassword ? "text" : "password"}
            id="password"
            placeholder="Enter your Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <i
            className={`fas ${showPassword ? "fa-eye" : "fa-eye-slash"}`}
            onClick={() => setShowPassword(!showPassword)}
          ></i>
        </div>

        {/* <Link> */}
        <div className="submit-btn">
          <input
            type="submit"
            className="btn"
            value="SIGN IN TO DASHBOARD"
            disabled={!email || !password ? true : false}
          />
        </div>
        {/* </Link> */}

        <label className="new-member">
          Don't have an account?{" "}
          <Link to="register">
            <span>SIGN UP</span>
          </Link>
        </label>
      </div>
    </form>
  );
};

export default LoginComp;
